import { render, staticRenderFns } from "./journal-detail.vue?vue&type=template&id=6d40e8aa&scoped=true&"
import script from "./journal-detail.vue?vue&type=script&lang=js&"
export * from "./journal-detail.vue?vue&type=script&lang=js&"
import style0 from "./journal-detail.vue?vue&type=style&index=0&id=6d40e8aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40e8aa",
  null
  
)

component.options.__file = "journal-detail.vue"
export default component.exports